




import {Component, Prop, Vue} from "vue-property-decorator";
import {LadingStore} from "../../store";

@Component({
    name: "LadingLabel"
})
export default class extends Vue {
    @Prop({ required: true, type: String })
    readonly id!: string;

    get label() {
        return `${LadingStore.data[this.id]?.ladingCode}`;
    }
}
